import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import {
    useNotify,
    useUpdate,
    useRefresh,
    useRecordContext,
    useTranslate,
} from "react-admin";
import { handleHttpError } from "shared/src/utils/errorHandler";
import { CarnetForm } from "./CarnetForm";

export const CreateCarnetDialog = ({ open, setShowCreateCarnetDialog }) => {
    const [update] = useUpdate();
    const notify = useNotify();
    const translate = useTranslate();
    const record = useRecordContext();
    const refresh = useRefresh();

    const onSave = (data) => {
        setShowCreateCarnetDialog(false);
        update(
            "rentals",
            {
                id: record.id,
                data: {
                    carnetData: [...(record?.carnetData || []), data],
                },
            },
            {
                onSettled: () => {
                    refresh();
                },
                onError: (e) => {
                    handleHttpError(e, notify);
                },
            }
        );
    };

    return (
        <Dialog fullWidth open={open}>
            <DialogTitle>{translate("equip.addCarnetItem")}</DialogTitle>
            <DialogContent>
                <CarnetForm
                    onCancel={() => setShowCreateCarnetDialog(false)}
                    onSave={onSave}
                    record={null}
                    action="create"
                    isAdditionalRow={false}
                />
            </DialogContent>
        </Dialog>
    );
};
